<lg-navbar position="fixed" [zIndex]="997">
  <div lgNavbarStart class="tw-flex tw-min-w-0 tw-items-center tw-gap-2 md:tw-gap-3">
    <lg-navbar-hamburger
      [open]="sidebarController.isOpen()"
      [mobileOnly]="false"
      ariaLabel="Abrir menú de navegación"
      (menuToggle)="toggleSidebar()"
    />
    <a
      routerLink="/priv/inicio"
      class="tw-inline-flex tw-min-w-0 tw-items-center tw-text-inherit tw-no-underline"
      aria-label="Ir al inicio"
    >
      <img
        src="assets/img/logo.png"
        alt="Logo de Fianly"
        width="36"
        height="36"
        loading="eager"
      />
    </a>
    <span
      class="tw-hidden tw-h-6 tw-w-px tw-shrink-0 tw-bg-gray-300 sm:tw-block"
      aria-hidden="true"
    ></span>
    <span class="tw-hidden tw-truncate tw-text-sm tw-font-medium tw-text-texto-secondary sm:tw-inline">
      Cobranza
    </span>
  </div>

  @if (sessionService.user?.validate_otp) {
    <div lgNavbarCenter class="tw-flex tw-min-w-0 tw-items-center tw-justify-center">
      <rate-table />
    </div>
  }

  <div lgNavbarEnd class="tw-flex tw-shrink-0 tw-items-center tw-gap-2 md:tw-gap-3">
    <navbar-profile />
  </div>
</lg-navbar>
